// types export
export type * from './types/events';
export type * from './types/pages';
export type * from './types/properties';
export type * from './types/screens';
export type * from './types/user';

// enum value export (enums need to be accessible at runtime)
export { EventName } from './types/events';
export { PageCategory, PageName, pageCategoryMap } from './types/pages';
export { ScreenCategory, ScreenName, screenCategoryMap } from './types/screens';

// base client export (platform-specific clients available via subpath exports)
export { BaseAnalyticsClient } from './client/base';
export type { AnalyticsConfig } from './client/base';

// export event tracking
export * from './events/index';

// constant export
// export * from './constants';
